export default __webpack_public_path__ + "static/media/vacan.44df2b12.png";